import React from 'react';
import { Tiles } from 'wsm-tiles';
import { useLabels, usePrefs, useRequestData } from 'wsm-common-data';
import { setClassNames } from '@ddc/classnames-js';
import { useLocationsData } from '../hooks/useLocationsData';

const Widget = () => {
	const labels = useLabels();
	const { deviceType } = useRequestData();
	const { locations, error, isLoading } = useLocationsData();
	const { widgetHeading } = usePrefs();
	const isDesktop = deviceType !== 'MOBILE';

	if (isLoading) {
		return <div>Loading...</div>;
	}
	if (error) {
		return <div>Error: something went wrong</div>;
	}

	const titleClasses = setClassNames([
		'text-center',
		isDesktop ? 'my-3' : 'my-3 pl-6'
	]);

	const tilesClasses = setClassNames([
		'my-5',
		isDesktop ? 'justify-content-center' : 'px-6 overflow-auto'
	]);

	return (
		<section>
			{widgetHeading && widgetHeading.trim() && (
				<h2 className={titleClasses}>{labels.get(widgetHeading)}</h2>
			)}
			<Tiles
				type="location"
				data={locations}
				layout={isDesktop ? 'grid' : 'carousel'}
				className={tilesClasses}
			/>
		</section>
	);
};

export default Widget;
